import buildMapTypeIds from './build-map-type-ids';
import { COOPERATIVE, NONE, ELEMENT_GEOMETRY, FEATURE_TYPE_MAP, ALL, DISABLE_TRANSPORTATION_STYLES, DISABLE_POI_STYLES, DISABLE_BOUNDARIES_STYLES, DISABLE_LABELS_STYLES, DEFAULT_SELECT_VALUE } from '../../constants';
const setCustomColor = (featureType, color, elementType) => color ? [{
  featureType,
  elementType: elementType || ELEMENT_GEOMETRY,
  stylers: [{
    color
  }]
}] : [];
const getFeatureStyles = ({
  enableRoads = true,
  enableFeatureTransportation,
  enableFeatureLabels,
  enableFeaturePoi,
  enableFeatureBoundaries
}) => {
  const customColors = [];
  // todo: enableRoads is a legacy option can be removed in later updates
  if (!enableFeatureLabels || !enableRoads) customColors.push(...DISABLE_LABELS_STYLES);
  if (!enableFeatureBoundaries || !enableRoads) customColors.push(...DISABLE_BOUNDARIES_STYLES);
  if (!enableFeaturePoi || !enableRoads) customColors.push(...DISABLE_POI_STYLES);
  if (!enableFeatureTransportation || !enableRoads) {
    customColors.push(...DISABLE_TRANSPORTATION_STYLES);
  }
  return customColors;
};
const setMapOptions = otherProps => {
  const {
    centerLatitude,
    centerLongitude,
    defaultZoom,
    enableZoom,
    maxZoom,
    minZoom,
    enablePan,
    enableStreetView,
    enableFullScreen,
    enableSatelliteView,
    enableTerrainScreen,
    waterColor,
    landscapeColor,
    landscapeColorAll,
    mapType
  } = otherProps;
  const customColors = [...getFeatureStyles(otherProps), ...setCustomColor(FEATURE_TYPE_MAP.waterColor, waterColor), ...setCustomColor(FEATURE_TYPE_MAP.landscapeColor, landscapeColor), ...setCustomColor(FEATURE_TYPE_MAP.landscapeColor, landscapeColorAll, ALL)];
  return {
    center: {
      lat: centerLatitude,
      lng: centerLongitude
    },
    zoom: defaultZoom,
    maxZoom: enableZoom ? maxZoom : defaultZoom,
    minZoom: enableZoom ? minZoom : defaultZoom,
    gestureHandling: enablePan || enableZoom ? COOPERATIVE : NONE,
    panControl: enablePan,
    zoomControl: enableZoom && minZoom !== maxZoom,
    disableDoubleClickZoom: !enableZoom,
    streetViewControl: enableStreetView,
    fullscreenControl: enableFullScreen,
    mapTypeControl: enableSatelliteView || enableTerrainScreen,
    mapTypeControlOptions: {
      mapTypeIds: buildMapTypeIds(enableSatelliteView, enableTerrainScreen)
    },
    mapTypeId: !mapType || mapType === DEFAULT_SELECT_VALUE ? undefined : mapType,
    styles: customColors
  };
};
export default setMapOptions;
//# sourceMappingURL=set-map-options.js.map